<template>
  <address
    v-if="$content.options.value.contact"
    class="not-italic uppercase w-70 p-10 text-center flex flex-col gap-5 items-center text-sm transition-[margin_background-color_color_border]"
  >
    <component
      :is="element.link ? 'a' : 'div'"
      v-bind="{
        href: element.link,
        target: element.link ? '_blank' : null,
      }"
      v-for="(element, elementIndex) in $content.options.value.contact.address"
      :key="`address-${elementIndex}`"
      :class="{ group: element.link }"
    >
      <p class="font-title mb-2.5">{{ element.title }}</p>
      <p class="group-hover:hover:text-pink transition-colors whitespace-break-spaces">
        {{ element.description }}
      </p>
    </component>
    <div>
      <p class="font-title mb-2.5">{{ $t('contact') }}</p>
      <a
        v-if="$content.options.value.contact.phone"
        :href="`tel:+${$content.options.value.contact.phone.replace(/\D/g, '')}`"
        target="_blank"
        class="block hover:text-pink transition-colors"
        >{{ $content.options.value.contact.phone }}</a
      >
      <a
        v-if="$content.options.value.contact.email"
        :href="`mailto:${$content.options.value.contact.email}`"
        target="_blank"
        class="block hover:text-pink transition-colors"
        >{{ $content.options.value.contact.email }}</a
      >
    </div>
    <div class="flex items-center justify-center gap-5">
      <template v-for="social in ['facebook', 'instagram', 'tiktok']" :key="`footer-${social}`">
        <a
          v-if="$content.options.value.contact[social]"
          :href="$content.options.value.contact[social]"
          target="_blank"
          class="text-pink text-[26px] hover:text-burgundy transition-colors social"
        >
          <IconSprite :id="social" />
        </a>
      </template>
    </div>
  </address>
</template>

<script lang="ts">
import IconSprite from '@/components/helpers/IconSprite.vue'

export default {
  name: 'SiteAddress',
  components: { IconSprite },
}
</script>
